<div mat-dialog-content>
  {{ message }}
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ "no" | translate }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ "yes" | translate }}
  </button>
</div>
